// utils/timeout.js
export const withTimeout = (promise, timeout = 5000) => {
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => {
        reject(new Error('Request timed out'));
      }, timeout);
  
      promise
        .then((response) => {
          clearTimeout(timer);
          resolve(response);
        })
        .catch((err) => {
          clearTimeout(timer);
          reject(err);
        });
    });
  };
  

  // Resolves a stored s3:// reference to a URL.
  //
  // /rest/public/image returns a width-appropriate WebP with a long cache
  // lifetime; the raw /rest/files endpoint returns the original PNG (often
  // ~275KB) with Cache-Control: no-cache. Pass a width matching the render size.
  export const processImageUrl = (url, width = 800) => {
    if (url?.startsWith("s3://")) {
      const encodedFilePath = encodeURIComponent(url.substring(5));
      return `${process.env.REACT_APP_API_BASE_URL}rest/public/image?ref=s3%3A%2F%2F${encodedFilePath}&w=${width}`;
    }
    return url || "";
  };
  

  

  